import React, { useCallback } from 'react';
import { useDispatch } from "react-redux";
import { selectOneSetting } from '../../../../util/store/selectors';
import { useSelector } from '../../../../util/store/store';
import { OverviewSetting } from "../../../../util/varibles/userSetting";
import { loginActions } from "../../../LoginPage/reducer";
import { CALENDAR_ID } from '../../constants';
import { TIMELINE_ZOOM_EVENT } from '../../useTimelineZoom';
import styles from './style.module.scss';

const weeks = [
    { id: 4, name: '4 weeks' },
    { id: 3, name: '3 weeks' },
    { id: 2, name: '2 weeks' },
    { id: 1, name: '1 week' }
];
interface IProps {
    keyId?: string
}

const WeekControl: React.FC<IProps> = ({ keyId = OverviewSetting.WEEK_PER_PAGE }) => {
    const selected = useSelector(selectOneSetting(keyId));
    const dispatch = useDispatch();
    const selectedIndex = Math.max(weeks.findIndex(({ id }) => id === selected), 0);

    const onClick = useCallback((value: number) => {
        if (value !== selected) {
            const calendar = document.getElementById(CALENDAR_ID);
            if (keyId === OverviewSetting.WEEK_PER_PAGE && calendar) {
                calendar.dispatchEvent(new CustomEvent(TIMELINE_ZOOM_EVENT, {
                    detail: { weekPerPage: value },
                }));
            } else {
                dispatch(loginActions.updateUserSetting([{ [keyId]: value }]))
            }
        }
    }, [selected, dispatch, keyId]);

    return <div
        className={styles.weekControl}
        style={{ '--selected-index': selectedIndex } as React.CSSProperties}
    >
        <div className={styles.selectedBackground} />
        {weeks.map(({ id, name }) => <div
            key={id}
            className={styles.weekOption}
            data-selected={id === selected}
            onClick={() => onClick(id)}
        >
            {name}
        </div>)}
    </div>;
};

export default WeekControl;
